import React from "react";
import {Modal} from "react-bootstrap";
import Button from "../Button/Button";
import {useModal} from "../../context/ModalContext";
import TariffTable from "../TariffTable/TariffTable";
// import {useTariff} from "../../context/TariffContext";
import tariffData from "../../data/tariffData.json";

const ModalA: React.FC = () => {
    const {showModalA, openModalB, closeModals} = useModal();
    // const {selectedTariffId} = useTariff();

    return (
        <Modal show={showModalA} onHide={closeModals} centered>
            <Modal.Header closeButton>
                <Modal.Title>{tariffData[0].titleTariff}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TariffTable table={tariffData[0].table}/>
            </Modal.Body>
            <Modal.Footer>
                <Modal.Title>{tariffData[0].price}</Modal.Title>
                <Button onClick={openModalB} classButton="redButton">Оформить заявку</Button>
                <Button onClick={closeModals} className="d-flex d-md-none">Вернуться назад</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalA;
